import { useQuery } from "@apollo/client";
import { GET_EXTERNAL_SIGN_EGOV_LINK } from "@/modules/gateway/features/open-external-sign/api/get-external-sign-egov-link";

export function useExternalSignEgovLink({ code }: { code?: string }) {
  const { data, loading } = useQuery(GET_EXTERNAL_SIGN_EGOV_LINK, {
    variables: { code: code as string },
    skip: !code,
  });

  return {
    launchEgovBusinessLink:
      data?.getExternalSignEgovLink.launchEgovBusinessLink,
    launchEgovMobileLink: data?.getExternalSignEgovLink.launchEgovMobileLink,
    qrCode: data?.getExternalSignEgovLink.qrCode,
    loading,
  };
}
